export const PATH = {
  login: "/login",

  emailLogin: "/login/email",
  pcLogin: "/pc/login",
  coachLogin: "/coach",
  applock: "/applock",
  applockSetup: "/applock-setup",
  kakaoLoginRedirect: "/oauth/kakao",
  kakaoLoginRedirectPromotion: "/promotion/oauth/kakao",
  redirect_apple: "/oauth/apple",
  onboarding: "/onboarding/:id",
  onboarding_new: "/onboarding_new/:type/:id",
  refund: "/refund",
  refundSurvey: "/refund-survey",
  programSetup1: "/program-setup-1/:type/:id",
  programSetup2: "/program-setup-2/:type/:id",
  programSetup3: "/program-setup-3/:type/:id",
  etc_where: "/onboarding_new/etc_where",
  recommend_who: "/onboarding_new/recommend_who",
  influencer_who: "/onboarding_new/influencer_who",

  home: "/:taskKey?",
  payment: "/payment",
  planUpgrade: "/plan-upgrade",

  commitment: "/commitment",

  tossPayments: "/toss-payments",
  tossPaymentsPlanUpgrade: "/toss-payments/plan-upgrade",
  tossPaymentsSuccess: "/toss-payments/success",
  tossPaymentsPlanUpgradeSuccess: "/toss-payments/plan-upgrade/success",
  tossPaymentsFail: "/toss-payments/fail",
  tossPaymentsPlanUpgradeFail: "/toss-payments/plan-upgrade/fail",

  newsletterSettings: "/newsletter/settings",

  selfCheck: "/self-check/:tool/:id",
  selfCheckEnd: "/self-check/:tool/end",

  guide: "/guide/:id",
  guideTw: "/guide/tw/:id",
  promotionBook: "/promotion/:type",
  account: "/mypage/account",
  support: "/support/faq",
  supportDetail: "/support/faq/detail",
  taskEditor: "/cowork",
  promotionPhoneNumberSubmit: "/benefit-apply",

  privacyPolicy: "/privacy-policy",
  termsOfService: "/terms-of-service",

  promotionOnboarding: "/promotion-onboarding/:type/:id",
  promotionLogin: "/promotion-login",
  promotion_redirect_apple: "/promotion/oauth/apple",
  promotionTosspaymentsSuccess: "/promotion-tosspayments/success",
  promotionTosspaymentsFail: "/promotion-tosspayments/fail",
  promotionCompleted: "/promotion-completed",
  promotionAlreadyUsed: "/promotion-already-used",

  referralEntry: "/with/:code",
  affiliateLogin: "/affiliate-login",
  affiliateResult: "/affiliate-result",

  partnerPayment: "/partner/:slug",
  partnerLogin: "/partner/:slug/login",
  partnerTosspaymentsSuccess: "/partner/:slug/toss-payments/success",
  partnerTosspaymentsFail: "/partner/:slug/toss-payments/fail",
  partnerNicknameSubmit: "/partner/:slug/nickname-submit",
};
